module.exports = __webpack_public_path__ + "img/plane.6b051399.svg";